module.exports = __webpack_public_path__ + "static/media/queue-logo.76ca54e1.png";